// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__10M_5","notes":"Notes_notes__3d34Q","note":"Notes_note__3nsVe","markdown":"Notes_markdown__uMYnF"};